import React from "react";
import ReactPlayer from "react-player";
import {Box, Typography, useMediaQuery} from "@mui/material"

import {DownloadButton, DownloadButtonType} from "../../../../components";

import FilePdfIcon from "../../../../assets/images/svgs/file-pdf.svg";
import {IVideoCardProps, styles} from "./videoCard-helpers";
import {theme} from "../../../../utils";

const VideoCard = (props: IVideoCardProps) => {
    const {mainTitle, description, downloadText, enableDownload = true, videoURL, thumbnailURL, mainWrapperSx, fileUrl} = props
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))

    return (
        <Box sx={{...styles.wrapper, ...mainWrapperSx}}>
            <Box
                sx={styles.inner}
            >
                {/* LEFT COLUMN */}
                <Box sx={{...styles.contentColumn, textAlign: isMobileX ? "center" : "left"}}>
                    <Typography sx={{...theme.typography.components.sectionTitle}}>
                        {mainTitle}
                    </Typography>

                    <Typography sx={{...theme.typography.components.sectionDescription, mt: "24px"}}>
                        {description}
                    </Typography>

                    {enableDownload && fileUrl && (
                        <Box pl={isMobileX ? "0px" : "36px"} mt="24px"
                             sx={isMobileX ? styles.downloadWrapper : undefined}>
                            <Typography
                                sx={{
                                    ...theme.typography.montseratH1,
                                    fontSize: "20px",
                                    color: theme.palette.primary.main
                                }}
                            >
                                {downloadText}
                            </Typography>

                            <Box sx={{
                                mt: "8px",
                                display: "flex",
                                justifyContent: isMobileX ? "center" : "flex-start"
                            }}>
                                <DownloadButton
                                    fileUrl={fileUrl}
                                    buttonIcon={FilePdfIcon}
                                    buttonText="Open PDF"
                                    buttonType={DownloadButtonType.Pdf}
                                />
                            </Box>
                        </Box>
                    )}
                </Box>

                {/* RIGHT COLUMN (VIDEO) */}
                <Box sx={styles.videoColumn} >
                    {thumbnailURL && (
                        <ReactPlayer
                            url={videoURL}
                            light={encodeURI(thumbnailURL)}
                            controls
                            width={"100%"}
                            height={"100%"}
                            playing={true}
                            style={{borderRadius: "8px",}}
                        />
                    )}
                </Box>
            </Box>
        </Box>
    )
}

export default VideoCard